import TotalNumberCardStyle from "css/pages/admin/dashboard/TotalNumberCard.module.css";

const TotalNumberCard = ({ total, title, info, icon, children }) => {
  return <div className={TotalNumberCardStyle.container}>{children}</div>;
};

export default TotalNumberCard;
